// Central Storage Services Export
// Provides clean imports for all storage functionality

// Imports for default export convenience
import * as storageDetection from './storageDetection';
import * as storageHelpers from './storageHelpers';
import * as encryptionService from './encryptionService';
import * as userDataService from './userDataService';
import * as purchaseStateService from './purchaseStateService';
import * as storageUtils from './storageUtils';

// Re-export all modules
export * from './storageDetection';
export * from './storageHelpers';
export * from './encryptionService';
export * from './userDataService';
export * from './purchaseStateService';
export * from './storageUtils';

// Default export combining all services
const storageServices = {
  ...storageDetection,
  ...storageHelpers,
  ...encryptionService,
  ...userDataService,
  ...purchaseStateService,
  ...storageUtils,
};

export default storageServices;

/**
 * Clear all caches for complete test isolation
 * This clears both the performance cache and storage availability cache
 */
export const clearAllCaches = () => {
  // Import functions dynamically to avoid circular dependencies
  const { clearPerformanceCache } = require('./userDataService');
  const { clearStorageAvailabilityCache } = require('./storageDetection');
  const { debugLog } = require('../debugUtils');

  clearPerformanceCache();
  clearStorageAvailabilityCache();

  // Clear analytics queues as well
  try {
    const {
      clearAnalyticsQueues,
    } = require('../../components/analytics/queueManagement');
    clearAnalyticsQueues();
  } catch (error) {
    // Silently continue if analytics module not available
  }

  debugLog('🗑️ All caches cleared for test isolation');
};
